import PropTypes from "prop-types";
import * as React from "react";
import { Checkbox } from "react-ui";

import { TextOverflow } from "../../../../Internals/TextOverflow/TextOverflow";
import { pullContext } from "../../../../TypingUtils";

import { Root } from "./FilterItem.styles";

interface FilterItemProps {
    onClick: (values: string[], checked: boolean) => void;
    description?: string;
    checked: boolean;
    values: string[];
    widths?: [number, number] | undefined;
    singleElement?: boolean;
    separator: string;
}

interface FilterItemState {
    checked: boolean;
}

interface FilterItemContext {
    menuWidth: number;
}

const MENU_PADDING = 20;
const CHECKBOX_WIDTH = 20;

export class FilterItem extends React.Component<FilterItemProps, FilterItemState> {
    public static contextTypes = { menuWidth: PropTypes.number };

    public constructor(props: FilterItemProps) {
        super(props);
        this.state = { checked: this.props.checked };
    }

    public render(): JSX.Element {
        return (
            <Root>
                <Checkbox checked={this.state.checked} onValueChange={this.handleOnChange}>
                    {this.renderItem()}
                </Checkbox>
            </Root>
        );
    }

    private renderItem(): JSX.Element {
        const values = [...this.props.values];
        if (this.props.description) {
            values.push(this.props.description);
        }
        const value = values.filter(Boolean).join(this.props.separator);
        const menuWidth = this.getContext().menuWidth;
        const width = typeof menuWidth === "number" ? menuWidth - MENU_PADDING * 2 - CHECKBOX_WIDTH : undefined;

        return (
            <TextOverflow
                text={value}
                pos="right middle"
                width={width}
                minHeight={this.props.singleElement ? "24px" : ""}
            />
        );
    }

    private readonly handleOnChange = (checked: boolean) => {
        this.setState({ checked: checked });
        this.props.onClick(this.props.values, checked);
    };

    private getContext(): FilterItemContext {
        return pullContext<FilterItemContext>(this);
    }
}
